module.exports = __webpack_public_path__ + "657c6a048405d0ec4ff72b69c0bb6b49.gif";